<template>
  <card-block>
    <card-header>
      Список заявок
      <template v-slot:right>
        <router-link :to="{name: 'submit-form.create'}" v-if="can('module.submit_form_1.create')">
          Добавить заявку
        </router-link>
      </template>
    </card-header>
    <card-body>
      <spinner-block v-model="progress">
        <div class="mb-3 row">
          <div class="col-12 col-md-2">
            <div class="small">Статус</div>
            <gui-select sm v-model="filter.send" @change="getList" :hilightOn="['all']">
              <option value="true">Отправленные</option>
              <option value="false">Не отправленные</option>
              <option value="all">Все</option>
            </gui-select>
          </div>
          <div class="col-12 col-md-5">
          </div>
          <div class="col-12 col-md-5">
            <div class="small">Поиск</div>
            <gui-search sm v-model="filter.search" @change="getList" :hilightOn="['', undefined]"/>
          </div>
        </div>
        <div v-if="data && data.data && data.data.length">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>Имя</th>
              <th class="d-none d-md-table-cell">Организация</th>
              <th class="d-none d-md-table-cell">Телефон</th>
              <th class="d-none d-md-table-cell">Email</th>
              <th class="d-none d-md-table-cell">Дата создания</th>
              <th class="d-none d-md-table-cell">Статус</th>
              <th class="text-right"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in data.data" :key="row.id">
              <td>
                <router-link :to="{name: 'submit-form.detail', params: {id: row.id}}" class="main-link">
                  {{ row.name ? row.name : '—' }}
                </router-link>
              </td>
              <td class="d-none d-md-table-cell">
                {{ row.organization ? row.organization : '—' }}
              </td>
              <td class="d-none d-md-table-cell">
                {{ row.phone ? row.phone : '—' }}
              </td>
              <td class="d-none d-md-table-cell">
                {{ row.email ? row.email : '—' }}
              </td>
              <td class="d-none d-md-table-cell">
                {{ toTime(row.created_at) }}
              </td>
              <td class="d-none d-md-table-cell">
                {{ row.is_send ? 'Отправлено' : 'Не отправлено' }}
              </td>
              <td class="text-right">

              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="alert alert-info">Список пуст</div>
      </spinner-block>
      <gui-paginate :data="data" ref="paginate" @change="getList"/>
    </card-body>
  </card-block>
</template>

<script>

export default {
  data: function () {
    return {
      data: null,
      progress: true,
      filter: {
        send: 'all',
        search: '',
      }
    }
  },
  props: {},
  computed: {},
  beforeMount() {
    this.filter = storageLoad('filter_' + this.$route.name, this.filter);
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {

      let v = _.clone(this.filter);
      v.search = '';
      storageSet('filter_' + this.$route.name, v);

      axiosGetValue('/api/admin/submit-form/list', {
            page: this.$refs.paginate.currentPage,
            per_page: this.$refs.paginate.perPage,
            filter: this.filter,
          },
          e => this.data = e, e => this.progress = e
      )
    }
  }
}
</script>